<ng-content></ng-content>
<button class="close-btn" mat-icon-button (click)="close()">
  <mat-icon>close</mat-icon>
</button>
